import React, { ReactElement } from 'react';
import { useCommonContext } from '../../hooks/useContexts';

const Spinner = (): ReactElement | null => {
  const { showLoadingOverlay } = useCommonContext();

  return showLoadingOverlay ? (
    <div
      data-testid="spinner"
      className="sui-top-0 sui-left-0 sui-right-0 sui-bottom-0 sui-w-full sui-h-full sui-z-max sui-flex sui-fixed sui-items-center sui-justify-center sui-bg-subtle sui-opacity-80"
    >
      <div
        data-testid="loading-indicator"
        className="sui-animate-spin"
        style={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          borderWidth: 6,
          borderColor: 'rgba(249, 99, 2, .2)',
          borderStyle: 'solid',
          borderLeftColor: '#f96302',
        }}
      />
    </div>
  ) : null;
};

export default Spinner;
